import { Base } from '@or-sdk/base';
import { SERVICE_KEY } from './constants';
export class EventManager extends Base {
    constructor(params) {
        const { token, discoveryUrl, requestAccountId, requestProvidersAccountId, eventManagerUrl } = params;
        super({
            token,
            discoveryUrl,
            requestAccountId: requestAccountId || false,
            requestProvidersAccountId: requestProvidersAccountId || false,
            serviceKey: SERVICE_KEY,
            serviceUrl: eventManagerUrl,
        });
    }
    makeRequest(params) {
        return this.callApi(params);
    }
    parseError(e) {
        return e;
    }
}
//# sourceMappingURL=EventManager.js.map